/* Quaglia CarPlay – Animationen (q-motion.js) */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  window.qMotionReady = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(sel, fn, root) { Array.prototype.forEach.call((root || d).querySelectorAll(sel), fn); }

  /* Einblenden beim Scrollen */
  var LIST = '.q-section .q-head, .q-brands .q-brand, .q-wa, .q-models-head, .q-grid .q-card, .q-steps-wrap, .q-step, .q-review, .q-faq__item, .q-ctabox, .q-results__media, .q-results__copy';
  var SEL = '.q-scope :is(' + LIST + ')';
  try { d.querySelector(SEL); } catch (e) { SEL = '.q-scope .q-wa'; reduce = true; }
  function showAll() { each(SEL, function (el) { el.classList.add('q-in'); }); html.classList.remove('q-motion'); }
  if (reduce || !('IntersectionObserver' in window)) {
    showAll();
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('q-in');
        io.unobserve(el);
        var delay = parseFloat(el.style.transitionDelay) || 0;
        setTimeout(function () { el.style.transitionDelay = ''; }, 900 + delay);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    each(SEL, function (el) {
      var p = el.parentElement, i = p ? Array.prototype.indexOf.call(p.children, el) : 0;
      el.style.transitionDelay = (Math.min(i % 8, 7) * 60) + 'ms';
      io.observe(el);
    });
    /* Sicherheitsnetz: nach 6 s ist alles sichtbar, was im Bild ist */
    setTimeout(function () {
      each(SEL, function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) el.classList.add('q-in');
      });
    }, 6000);
  }

  /* Zähler in den Kennzahlen */
  if (!reduce) {
    var start = html.classList.contains('q-seen') ? 1100 : 2900;
    each('[data-q-count]', function (el) {
      var txt = el.textContent, m = txt.match(/\d+/);
      if (!m) return;
      var n = parseInt(m[0], 10);
      if (n < 2) return;
      var pre = txt.slice(0, m.index), post = txt.slice(m.index + m[0].length);
      el.textContent = pre + '0' + post;
      setTimeout(function () {
        var t0 = null;
        function step(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / 1800), e = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + Math.round(n * e) + post;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, start);
    });
  }

  /* Cockpit neigt sich mit der Maus */
  if (!reduce && window.matchMedia && matchMedia('(hover: hover)').matches) {
    each('[data-q-tilt]', function (w) {
      var t = w.querySelector('.q-tilt'), raf;
      if (!t) return;
      w.addEventListener('mousemove', function (e) {
        var r = w.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          t.style.setProperty('--ry', ((x - 0.5) * 16).toFixed(2) + 'deg');
          t.style.setProperty('--rx', ((0.5 - y) * 12).toFixed(2) + 'deg');
          t.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          t.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        });
      });
      w.addEventListener('mouseleave', function () {
        cancelAnimationFrame(raf);
        ['--rx', '--ry'].forEach(function (k) { t.style.setProperty(k, '0deg'); });
        ['--mx', '--my'].forEach(function (k) { t.style.setProperty(k, '50%'); });
      });
    });
  }

  /* Fortschrittsbalken im Header */
  var bar = d.querySelector('.q-progress');
  if (bar) {
    var ticking = false;
    var update = function (target) {
      var s = (target && target.nodeType === 1) ? target : (d.scrollingElement || html);
      var max = s.scrollHeight - s.clientHeight;
      if (max <= 4) return;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, s.scrollTop / max)).toFixed(4) + ')';
    };
    d.addEventListener('scroll', function (e) {
      var tg = e.target;
      if (tg !== d && !(tg.classList && tg.classList.contains('page-wrapper'))) return;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(tg === d ? null : tg); });
    }, { capture: true, passive: true });
  }

  /* Modell-Karten klappen beim Markenwechsel auf */
  d.addEventListener('q:brand', function (e) {
    var panel = e.detail && e.detail.panel;
    if (!panel || reduce) return;
    each('.q-card', function (c, i) {
      c.classList.remove('q-flip');
      void c.offsetWidth;
      c.style.animationDelay = (Math.min(i, 11) * 0.06).toFixed(2) + 's';
      c.classList.add('q-flip', 'q-in');
    }, panel);
  });
})();
